import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../../components/ui/table";
import { useNavigate } from "react-router";


export default function TasksTable() {

  return(
    <>
      <Table>
        <TableHeader className="bg-[#d9ffa3]">
          <TableRow>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Task Area Name
                  </span>
                </div>
              </div>
            </TableCell>
          </TableRow>
        </TableHeader>
      </Table>
    </>
  )
}